<template>
  <div class="page-contain"
       v-if="tradeState != -1">
    <div class="page-top"
         :style="`background: ${orderTopInfo.bg}`">
      <div>
        <div class="page-text-top">{{orderTopInfo.big}}</div>
        <div class="page-text-bottom">{{orderInfo.trade_state === 0 ?  `订单剩余${this.hour}小时${this.min}分钟` : orderTopInfo.small }}</div>
      </div>
      <img class="order-icon"
           :src="orderTopInfo.img" />
    </div>
    <div class="product-info-block">      
      <div v-if="productInfo && productInfo.related_products">
        <div class="product-detail" v-for="(product, index) in productInfo.related_products" :key="index">
          <img class="img" :src="product.cover" />
          <div class="info">
            <div class="title">{{product.title}}</div>
            <div class="subtitle">{{product.description}}</div>
          </div>
          <div class="price">{{ product.original_price | priceFilter }}</div>
        </div>
      </div>

      <div class="product-info" v-else>
        <img class="product-pic"
             :src="orderInfo.assemble_product_cover.small_cover" />
        <div class="product-context">
          <div class="product-title">{{orderInfo.assemble_product_title}}</div>
        </div>
      </div>
      <div class="button-line"
           v-if="tradeState === 0">
        <div class="gray-button"
             @click.stop="$refs.orderDialog.show()">取消订单</div>
        <div class="gray-button"
             @click="$refs.serveDialog.show()">联系客服</div>
      </div>
    </div>

    <div class="blank-line"></div>
    <div class="order-pay-info">
      <div class="block-title">付款信息</div>
      <div class="order-pay-line">
        <div>商品总价:</div>
        <div class="gray-font">{{orderInfo.price | priceFilter}}</div>
      </div>
      <div class="order-pay-line">
        <div>实付款:</div>
        <div class="orange-font">{{orderInfo.total_fee | priceFilter}}</div>
      </div>
    </div>
    <div class="blank-line"></div>
    <div class="order-pay-info">
      <div class="block-title">订单信息</div>
      <div class="order-info-line"
           v-if="orderInfo.physical_goods_flag">
        <div class="order-info-title">手机号：</div>
        <div class="order-info-content">{{orderInfo.cellphone}}</div>
      </div>
      <div class="order-info-line address-line"
           v-if="orderInfo.physical_goods_flag">
        <div class="order-info-title">收货地址：</div>
        <div class="order-info-content width-max">{{orderInfo.address}}</div>
      </div>
      <div class="order-info-line">
        <div class="order-info-title">订单号：</div>
        <div class="order-info-content num-width-max">{{orderInfo.out_trade_no}}</div>
        <div class="copy-btn"
             v-clipboard:copy="orderInfo.out_trade_no"
             v-clipboard:success="onCopy"
             v-clipboard:error="onError">复制订单号</div>
      </div>
      <div class="order-info-line">
        <div class="order-info-title">下单时间：</div>
        <div class="order-info-content">{{orderInfo.create_time | timeFilter}}</div>
      </div>
    </div>
    <div class="blank-line"></div>
    
    <div class="info-line">
      <div class="info-title-line">
        <div class="info-line-title">支付方式</div>
      </div>
      <div class="pay" @click="changePayMode('aliPay')">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/alipay.png'"
          />
          <span class="title">支付宝支付</span>
        </div>
        <img
          v-if="payMode == 'aliPay'"
          class="check"
          :src="aliURL + '/h5/mulit/art-product/imgs/check-yellow.png'"
        />
        <div class="uncheck" v-else></div>
      </div>
      <div class="pay" @click="changePayMode('wxPay')">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/wxpay.png'"
          />
          <span class="title">微信支付</span>
        </div>
        <img
          v-if="payMode == 'wxPay'"
          class="check"
          :src="aliURL + '/h5/mulit/art-product/imgs/check-yellow.png'"
        />
        <div class="uncheck" v-else></div>
      </div>

      <div class="pay" @click="changePayMode('hbfq')" v-show="isHbfq">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/huabei.png'"
          />
          <span class="title">花呗分期 <span class="hbfq-tip">{{ hbfqTip }}</span></span>
        </div>
        <img
          v-if="payMode == 'hbfq'"
          class="check"
          :src="aliURL + '/h5/mulit/art-product/imgs/check-yellow.png'"
        />
        <div class="uncheck" v-else></div>
      </div>
      <div class="huabei" v-show="isHbfq">
        <template v-for="(item,index) in hbfqPrices">
          <div class="huabei-item" v-bind:class="{ active: item.active }" @click="changeHbfqNum(item.num)">
            <span class="price">¥{{ (item.price + item.fee) / 100}} × {{item.num}}期</span>
            <span>含手续费¥{{ item.fee / 100 }}/期</span>
            <img v-if="item.recommend" class="recommend" :src="aliURL + '/h5/mulit/art-product/imgs/recommend.png'">
          </div>
        </template>        
      </div>
    </div>
    
    <div class="bottom-blank"></div>    
    <div class="page-bottom">
      <div class="pay-bottom"
           v-if="tradeState == 0">
        <div class="bottom-price">{{ orderInfo.total_fee | priceFilter }}</div>
        <van-button class="pay-btn"
                  @click="getWxPayInfo">提交订单</van-button>

        <!-- <div class="sale-price">已优惠 {{orderInfo.coupon_fee | priceFilter}}</div>
        <div class="pay-right">
          <div class="final-price">{{orderInfo.total_fee | priceFilter}}</div>
          <van-button class="submit-order-btn"
                      @click="getWxPayInfo">提交订单</van-button>
        </div> -->
      </div>
      <div class="finish-bottom"
           v-if="tradeState == 1">
        <div class="finish-btn"
             @click="$refs.serveDialog.show()">
          <img class="finish-icon"
               :src="imgUrl + 'customer-white-color.png'" />
          <div>联系客服</div>
        </div>
      </div>
      <van-button class="bottom-btn"
                  v-if="tradeState == 2"
                  @click="reBuy">重新下单</van-button>
    </div>
    <ServeDialog ref="serveDialog"
                 :cellphone="cellphone"></ServeDialog>
    <Dialog ref="orderDialog"
            @confirm="$refs.orderDialog.hide()"
            @cancel="cancelOrder"
            :type="1" />
  </div>
</template>
<script>
import OrderApi from "api/OrderApi";
import ProductApi from "api/ProductApi";
import Dialog from "@/components/Dialog";
import ServeDialog from "@/components/ServeDialog";
import { wexinPay } from "assets/enjory.js";
import wxPay from "assets/wxPay.js"
import roundHalfEven from "round-half-even"

export default {
  components: {
    Dialog,
    ServeDialog
  },

  data() {
    return {
      imgUrl: 'https://sc2.hexiaoxiang.com/h5/purchase/img/',
      hour: "00",
      min: "00",
      tradeState: -1,
      orderTopInfo: {},
      orderInfo: {},
      productInfo: {
        assemble_product_cover: {}
      },
      cellphone: '',
      aliURL: 'https://sc2.hexiaoxiang.com',
      payMode: '',
      selectedHbfqNum: 0, //花呗分的期数
      productId: ''
    }
  },

  created() {
    this.getOrderInfo()
  },

  destroyed() {
    clearTimeout(this.downTimer);
  },

  computed: {
    // 是否支持花呗分期
    isHbfq() {
      if (!this.productInfo || !this.productInfo.pay_info) {
        return false;
      }

      const { support_hb_fq } = this.productInfo.pay_info
      return support_hb_fq == 1
    },

    // 花呗分期每期价格，包含手续费
    hbfqPrices() {
      if (!this.isHbfq) {
        return;
      }

      let that = this
      const { hb_fq_nums, fq_free_rate_nums } = this.productInfo.pay_info
      let ary = []
      if (hb_fq_nums && hb_fq_nums.length) {
        ary = hb_fq_nums.map(n => {
          return {
            num: n, 
            price: that.termPrice(n), 
            fee: that.feePrice(n),
            active: that.selectedHbfqNum == n && that.payMode == 'hbfq',
            recommend: fq_free_rate_nums.find(e => {return e == n}) 
          }
        })
      }

      console.log(ary)
      return ary
    },

    maxFreeRateNum() {
      if (!this.isHbfq) {
        return;
      }

      const { fq_free_rate_nums } = this.productInfo.pay_info
      return (fq_free_rate_nums && fq_free_rate_nums.length) ? Math.max(...fq_free_rate_nums) : 0
    },

    maxFqNum() {
      if (!this.isHbfq) {
        return;
      }

      const { hb_fq_nums } = this.productInfo.pay_info
      return (hb_fq_nums && hb_fq_nums.length) ? Math.max(...hb_fq_nums) : 0
    },  

    hbfqTip() {
      if (!this.isHbfq) {
        return;
      }

      if (this.maxFreeRateNum) {
        return this.maxFreeRateNum + '期免手续费'
      }

      return;
    }   
  },
  methods: {
    termPrice(num) {
      if (!this.isHbfq) {
        return;
      }

      let { price } = this.orderInfo
      let real_price =  price
      const { support_hb_fq, fq_free_rate_nums, hb_fq_nums, hb_fq_rate, hb_fq_seller_percent } = this.productInfo.pay_info
      if (num < 3) {
        return;
      }

      price = Math.floor(real_price / num)
      return (price < 1) ? real_price : price
    },

    feePrice(num) {
      if (!this.isHbfq) {
        return;
      }

      let { price } = this.orderInfo
      let real_price =  price
      const { support_hb_fq, fq_free_rate_nums, hb_fq_nums, hb_fq_rate, hb_fq_seller_percent } = this.productInfo.pay_info
      let rate = hb_fq_rate[num]

      //如果分期有free
      if (fq_free_rate_nums.find(e => { return e == num })) {
        rate = 0
      }

      if (hb_fq_seller_percent == 100) {
        rate = 0
      }      

      let totalFee = roundHalfEven(real_price * rate)
      let fee = Math.floor(totalFee/ num)
      return fee
    },

    changeHbfqNum(num) {
      this.payMode = 'hbfq'
      this.selectedHbfqNum = num
    },

    changePayMode(payMode) {
      this.payMode = payMode

      if (payMode == 'hbfq' && this.selectedHbfqNum == 0) {
        const { hb_fq_nums } = this.productInfo.pay_info
        if (hb_fq_nums && hb_fq_nums.length > 0) {
          this.selectedHbfqNum = hb_fq_nums[0]
        }
      }
    },

    // 获取商品信息
    getProductInfo() {
      ProductApi.getProductDetail({
        series_number: this.productId
      }).then(res => {          
        this.productInfo = res.data          
      })
    },

    getOrderInfo() {
      OrderApi.getOrderDetail({
        out_trade_no: this.$route.query.out_trade_no
      }).then(res => {
        const { assemble_product_id, trade_state, expire_time, sub_orders, cellphone, address, out_trade_no, create_time, physical_goods_flag } = res.data
        this.orderInfo = res.data
        this.productId = assemble_product_id
        this.getProductInfo()

        if (trade_state === 0) {
          this.countDown(expire_time)
        }
        this.getServiceCellphone()
        this.stateRender(trade_state)
        !this.$route.query.payMode && (this.changePayMode('aliPay'))
      })
    },

    // 获取客服电话
    getServiceCellphone() {
      ProductApi.getCellPhone({
        staff_id: localStorage.getItem('staffId')
      }).then(res => {
        this.cellphone = res.data.cellphone
      })
    },

    getWxPayInfo() {
      if (this.payMode == 'wxPay') {
        wxPay.pay({
          out_trade_no: this.orderInfo.out_trade_no,
          subject: this.orderInfo.assemble_product_title
        }).then(res => {
          res && wexinPay(res, this.paySuc, this.payError); // 微信SDK支付
        })
      } else if (this.payMode == 'aliPay' || this.payMode == 'hbfq') {        
        this.$router.push(`/goOther?out_trade_no=${this.orderInfo.out_trade_no}&payMode=${this.payMode}&hbfq_num=${this.selectedHbfqNum}&productId=${this.orderInfo.assemble_product_id}&key=${this.$store.state.key}&title=${this.orderInfo.assemble_product_title}`)
      } else {
        this.$toast("请选择支付方式!");
        return;
      }
    },

    paySuc() {
      const { out_trade_no, assemble_product_id } = this.orderInfo
      OrderApi.getOrderStatus({
        out_trade_no
      }).then(res => {
        if (res.data.trade_state === 1) {
          this.$router.replace({
            name: 'paySuc',
            query: {
              productId: assemble_product_id
            }
          });
        }
      }).catch(res => {
        this.paySuc();
      })
    },

    payError() {
      this.$toast("支付失败, 请重试");
    },

    // 取消订单
    cancelOrder() {
      OrderApi.deleteOrder({
        out_trade_no: this.orderInfo.out_trade_no
      }).then(res => {
        this.$toast("取消订单成功")
        setTimeout(() => {
          this.$router.go(-1);// 返回上一层
        }, 3000);
      })
    },

    // 重新购买
    reBuy() {
      this.$router.push({
        name: 'home',
        query: {
          productId: this.orderInfo.assemble_product_id
        }
      });
    },

    stateRender(tradeState) {
      const list = [
        {
          status: 0,
          big: '等待付款',
          small: `订单剩余${this.hour}小时${this.min}分钟`,
          bg: '#FFAE00',
          img: 'https://sc2.hexiaoxiang.com/h5/purchase/img/dzf.png'
        },
        {
          status: 1,
          big: '交易完成',
          small: '课程老师会在24小时内与您联系 请您留意并接听电话',
          bg: '#16CD65',
          img: 'https://sc2.hexiaoxiang.com/h5/purchase/img/ok1.png'
        },
        {
          status: 2,
          big: '交易关闭',
          small: '很遗憾，你失去了一次为孩子提高成绩的机会',
          bg: '#2D2E3F',
          img: 'https://sc2.hexiaoxiang.com/h5/purchase/img/jygb.png'
        }]
      this.orderTopInfo = list[tradeState]
      this.tradeState = tradeState
    },

    countDown(end) {
      // 获取当前时间
      const now = new Date().getTime();
      const leftTime = end - now;
      if (leftTime > 0) {
        this.downTimer = setTimeout(() => {
          const d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
          const h = Math.floor((leftTime / 1000 / 60 / 60) % 24) + d * 24;
          const m = Math.floor((leftTime / 1000 / 60) % 60);
          this.hour = h > 9 ? h : '0' + h;
          this.min = m > 9 ? m : '0' + m;
          this.countDown(end);
        }, 1000);
      } else {
        clearTimeout(this.downTimer);
      }
    },

    // 复制成功
    onCopy() {
      this.$toast('复制成功');
    },

    // 复制失败
    onError() {
      this.$toast('复制失败');
    },
  },
  filters: {
    timeFilter(val) {
      const time = new Date(val)
      const hour = time.getHours() > 9 ? time.getHours() : "0" + time.getHours()
      const min = time.getMinutes() > 9 ? time.getMinutes() : "0" + time.getMinutes()
      const sec = time.getSeconds() > 9 ? time.getSeconds() : "0" + time.getSeconds()
      return `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日 ${hour}:${min}:${sec}`
    },
    priceFilter(val) {
      return val ? "￥" + (val / 100) : ''
    },
    welFilter(val) {
      let origin = 0
      val.sub_orders && val.sub_orders.forEach(v => {
        origin += v.coupon_fee
      })
      return "￥" + (origin / 100)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../style/mixin.scss";
.page-contain {
  width: 100%;
  .page-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 22px 20px;
    width: 100%;
    .page-text-top {
      margin-bottom: 4px;
      line-height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .page-text-bottom {
      line-height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .order-icon {
      width: 40px;
      height: 40px;
    }
  }
  .product-info-block {
    box-sizing: border-box;
    padding: 16px 20px 10px;
    width: 100%;
    .product-info {
      display: flex;
      width: 100%;
      margin-bottom: 16px;

      .product-pic {
        margin-right: 16px;
        border-radius: 8px;
        width: 88px;
        height: 88px;
      }
      .product-context {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .product-title {
          margin-bottom: 4px;
          line-height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(45, 46, 63, 1);
        }
        .product-introduce {
          line-height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(138, 142, 153, 1);
        }
      }
    }

    .product-detail {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .img {
        width: 52px;
        height: 52px;
        margin-right: 10px;
        border-radius: 6px;
      }
      .info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .title {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #3c3531;
          margin-bottom: 2px;
          height: 20px;
          display: flex;
          align-items: center;
        }
        .subtitle {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #a7a4a1;
          margin-top: 2px;
          height: 17px;
          display: flex;
          align-items: center;
        }
      }
      .price {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #3c3531;
        letter-spacing: 0;
      }
    }
  }
  .button-line {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #ddd;
    padding-top: 16px;
    width: 100%;
    .gray-button {
      margin-left: 16px;
      border-radius: 4px;
      border: 1px solid rgba(138, 142, 153, 1);
      width: 80px;
      height: 32px;
      line-height: 32px;
      background: rgba(255, 255, 255, 1);
      font-size: 14px;
      color: rgba(138, 142, 153, 1);
      text-align: center;
    }
  }
  .order-pay-info {
    box-sizing: border-box;
    padding: 16px 20px;
    width: 100%;
    .block-title {
      margin-bottom: 12px;
      line-height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(45, 46, 63, 1);
    }
    .order-pay-line {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      line-height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(45, 46, 63, 1);
      .gray-font {
        color: #8a8e99;
      }
      .orange-font {
        color: #fe693f;
      }
    }
    .order-info-line {
      display: flex;
      margin-bottom: 10px;
      line-height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(45, 46, 63, 1);
      .order-info-title {
        margin-right: 4px;
        width: 70px;
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(45, 46, 63, 1);
      }
      .order-info-content {
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(138, 142, 153, 1);
      }
      .copy-btn {
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(254, 105, 63, 1);
      }
      .num-width-max {
        margin-right: 28px;
        width: 160px;
        font-size: 13px;
      }
      .width-max {
        width: 249px;
      }
    }
    .address-line {
      border-bottom: 1px solid #ddd;
      padding-bottom: 16px;
    }
  }
  .bottom-blank {
    width: 100%;
    height: 49px;
  }

  .page-bottom {
    
  }

  .page-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    .pay-bottom {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // box-sizing: border-box;
      // padding-left: 20px;
      // width: 100%;
      // background: #fff;
      // box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.08);
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100vw;
      height: 76px;
      background: white;
      padding: 0px 10px 10px 20px;
      box-sizing: border-box;
      .bottom-price {
        font-size: 28px;
        font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
        font-weight: bold;
        color: #FF7B4C;
        line-height: 40px;
      }
      .pay-btn {
        width: 172px;
        height: 56px;
        background: #FFD70A;
        border-radius: 28px;
        font-size: 18px;
        font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
        font-weight: bold;
        color: #9E531D;
        line-height: 26px;
      }
      .sale-price {
        line-height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(45, 46, 63, 1);
      }
      .pay-right {
        display: flex;
        align-items: center;
        .final-price {
          margin-right: 16px;
          line-height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(254, 105, 63, 1);
        }
        .submit-order-btn {
          width: 139px;
          height: 49px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          background: #fe693f;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .finish-bottom {
      display: flex;
      justify-content: center;
      padding: 4px 0;
      width: 100%;
      .finish-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 12px 37px;
        width: 168px;
        height: 48px;
        background: rgba(254, 105, 63, 1);
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        .finish-icon {
          margin-right: 6px;
          width: 24px;
          height: 24px;
        }
      }
    }
    .bottom-btn {
      width: 375px;
      height: 46px;
      background: rgba(254, 105, 63, 1);
      font-size: 16px;
      color: #ffffff;
    }
  }
}
.blank-line {
  width: 100%;
  height: 8px;
  background: #f0f0f5;
}

.info-line {
  margin-bottom: 8px;
  box-sizing: border-box;
  padding: 16px 20px;
  width: 100%;
  background: white;
  .info-title-line {
    display: flex;
    align-items: flex-end;
    .info-line-title {
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: rgba(45, 46, 63, 1);
    }
    .info-line-tip {
      margin-left: 7px;
      line-height: 23px;
      font-weight: 400;
      font-size: 13px;
      color: #8a8e99;
    }
  }
  .address-info {
    margin-top: 7px;
    box-sizing: border-box;
    border-radius: 7px;
    padding: 7px 15px;
    width: 330px;
    min-height: 82px;
    background: #f5f5f7;
    @include verticalCenter;
    .address-info-content {
      width: 238px;
      @include fontBase(13px, 400, rgba(45, 46, 63, 1), 19px);
      .address-info-content-top {
        @include justified(0);
        margin-bottom: 7px;
      }
      .address-info-content-bottom {
        text-align: justify;
      }
    }
    .address-info-line {
      margin-left: 15px;
      width: 1px;
      height: 48px;
      background: rgba(216, 216, 216, 1);
    }
    .address-info-btn {
      @include fontBase(13px, 400, rgba(252, 155, 48, 1), 19px);
      margin-left: 15px;
    }
  }
  .new-address {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 3px;
    border: 1px solid rgba(252, 155, 48, 1);
    box-sizing: border-box;
    padding: 0 11px;
    height: 32px;
    margin-top: 15px;
    width: 126px;
    line-height: 32px;
    font-size: 13px;
    font-weight: 500;
    color: rgba(252, 155, 48, 1);
    .add-icon {
      width: 11px;
      height: 11px;
    }
  }
  .note-input {
    margin-top: 8px;
    border-radius: 8px;
    width: 335px;
    background: rgba(245, 245, 247, 1);
  }
  .input-line {
    display: flex;
    align-items: center;
    margin-top: 7px;
    .input-label {
      margin-right: 15px;
      line-height: 21px;
      font-size: 15px;
      color: rgba(138, 142, 153, 1);
    }
    .input-label-short {
      margin-right: 0;
    }
    .long-input {
      width: 251px;
      background: rgba(245, 245, 247, 1);
    }
    .short-input {
      margin-right: 20px;
      width: 130px;
      background: rgba(245, 245, 247, 1);
    }
    .code-btn {
      width: 101px;
      height: 37px;
      line-height: 37px;
      background: #fe693f;
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
}

.pay {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  background: #ffffff;
  .check {
    width: 20px;
    height: 20px;
  }
  .uncheck {
    width: 16px;
    height: 16px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 2px solid #AEACAA;
    box-sizing: border-box;
    margin-right: 4px;
  }
  .wx-icon {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 22px;

    .hbfq-tip {
      font-size: 14px;
      font-family: Resource-Han-Rounded-CN-Medium, Resource-Han-Rounded-CN;
      font-weight: 500;
      color: #FF7B4C;
      line-height: 22px;
    }
  }
  .left {
    display: flex;
    align-items: center;
  }
}

.pay + .pay::before {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 0px;
  top: 0;
  left: 0px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.huabei {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px 0px 8px 0px;
  justify-content: space-between;
  align-content: space-between;
  height: 110px;

  .huabei-item {
    background: #F5F5F5;
    border-radius: 10px;
    width: 43.5vw;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;

    span {
      font-size: 12px;
      font-family: Resource-Han-Rounded-CN-Medium, Resource-Han-Rounded-CN;
      font-weight: 400;
      color: #726E6B;
      line-height: 19px;
    }

    .price {
      font-size: 14px;
      font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
      font-weight: bold;
      color: #3C3531;
      line-height: 19px;
    }
    .recommend {
      position:absolute;
      top: 0px;
      left: 0px;
      width: 17px;
      height: 16px;
    }
  }

  .active {
    background: rgba(255, 123, 76, 0.12);
    border-radius: 10px;
    border: 2px solid #FF7B4C;
    span {
      font-size: 12px;
      font-family: Resource-Han-Rounded-CN-Medium, Resource-Han-Rounded-CN;
      font-weight: 400;
      color: #FF7B4C;
      line-height: 19px;
    }

    .price {
      font-size: 14px;
      font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
      font-weight: bold;
      color: #FF7B4C;
      line-height: 19px;
    }
  }
}

/deep/ .van-button {
  padding: 0;
}
</style>